/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * A company that appears in a talent flow (previous or next employer).
 */
export interface CompanyEmployerFlowItem {
  company_id: string;
  name: string;
  domain?: string | null;
}
